/* Generated by tools/build-data.mjs. Do not edit by hand. */
export const DATA_FILES = {
  trees: "/data/trees.30d08f24.json",
  content: {
    en: "/data/content.en.a3a74342.json",
    ru: "/data/content.ru.9f2630ca.json",
    el: "/data/content.el.586b34ca.json",
  },
} as const;

export type ContentLanguage = keyof typeof DATA_FILES.content;
